<svelte:options customElement="hb-dashboard-card1" />

<script lang="ts">
  /**
   * Svelte Dashboard Card 1 WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import type { Component } from "./types/webcomponent.type";

  let {
    id = "",
    // style,
    body: bodyRaw = { noborder: false },
    header: headerRaw,
  }: Component = $props();

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  /** JSON attributes arrive as strings; mutating props in $effect does not refresh the template in Svelte 5. */
  const header = $derived.by((): Component["header"] | undefined => {
    let h: unknown = headerRaw;
    if (h == null) return undefined;
    if (typeof h === "string") {
      const s = h.trim();
      if (!s) return undefined;
      try {
        return JSON.parse(s) as Component["header"];
      } catch {
        return undefined;
      }
    }
    return h as Component["header"];
  });

  const body = $derived.by((): NonNullable<Component["body"]> => {
    let b: unknown = bodyRaw;
    if (b == null) return { noborder: false };
    if (typeof b === "string") {
      const s = b.trim();
      if (!s) return { noborder: false };
      try {
        b = JSON.parse(s);
      } catch {
        return { noborder: false };
      }
    }
    if (!b || typeof b !== "object" || Array.isArray(b)) {
      return { noborder: false };
    }
    const o = b as { noborder?: boolean };
    return { noborder: o.noborder ?? false };
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>

<div part="card" class="card">
  <header class="card-header">
    <slot name="header_content">
      <p
        class="card-header-title hb-dashboard-card1-header is-flex is-justify-content-space-between is-align-items-center is-flex-wrap-nowrap mb-0"
      >
        <span class="hb-dashboard-card1-header-label is-flex is-align-items-center">
          {#if header?.label}
            {#if header.icon}
              <i class="bi bi-{header.icon} mr-2"></i>
            {/if}
            <span class="hb-dashboard-card1-header-label-text">{header.label}</span>
          {/if}
        </span>
        {#if header?.badge}
          <span class="tag is-light hb-dashboard-card1-header-badge">{header.badge}</span>
        {/if}
      </p>
    </slot>
  </header>
  <div class="card-content" class:p-0={Boolean(body?.noborder)}>
    <slot name="content">
      <!-- {#if placeholder?.type}
				{#if placeholder.type === "text" && placeholder.content}
					<div part="text_placeholder" id="text_placeholder">
						{placeholder.content}
					</div>
				{:else}
					todo
				{/if}
			{/if} -->
    </slot>
  </div>
  <!-- <div class="card-footer text-muted"><slot name="footer_content" /></div> -->
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
